import {
    createRegisterableComponentWithData,
    ePaperLatestEditionDataDefinationLoader,
} from '@news-mono/web-common'
import React from 'react'
import { LatestEdition } from './LatestEdition'

export const ePaperPageLatestEditionRegistration =
    createRegisterableComponentWithData(
        'epaper-page-latest-edition',
        ePaperLatestEditionDataDefinationLoader,
        ({}, data, services) => {
            console.log(data, 'this should be the API response data')
            if (data.loaded) {
                return (
                    <LatestEdition
                        latestEdition={data.result.latestIssues[0]}
                        allEditions={data.result.latestIssues}
                        onEvent={services.onEvent}
                    />
                )
            }
            return (
                //maybe send down some default values if data no loaded
                null
            )
        },
    )
